export const getPathFromEvent = <E extends Event, R extends EventTarget>(event: E): R[] =>
  (<any>event).path || (event.composedPath && event.composedPath()) || [];
